export default __webpack_public_path__ + "static/media/stunningpunch4.5bc0da25.png";